<template>
  <div>
    <div class="info-section">
      <p class="info-text">
        This report generates an archive containing account and custodian information for billing purposes.
        The report will include all non-archived accounts for your firm.
      </p>
    </div>

    <div class="button-group">
      <button 
        type="button" 
        class="btn btn-primary action-button" 
        @click="generateReport"
        :disabled="isGenerating"
      >
        <i class="fas fa-download mr-2"></i>
        {{ isGenerating ? 'Generating...' : 'Download Report' }}
      </button>
    </div>
  </div>
</template>

<script>
import { Api } from "./../../../factory";
import { alert } from "./../../../service";

export default {
  data() {
    return {
      isGenerating: false
    };
  },
  methods: {
    async generateReport() {
      this.isGenerating = true;

      try {
        const { data } = await Api.post("reports/billing", {});
        this.downloadZip(data);
      } catch (err) {
        alert.error(`Error generating report: ${err.message}`);
      } finally {
        this.isGenerating = false;
      }
    },
    downloadZip(data) {
      if (!data || !data.zipContent || !data.zipFileName) {
        alert.error("Invalid zip file data");
        return;
      }

      const binaryString = window.atob(data.zipContent);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = data.zipFileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.info-section {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #0c2b4b;
}

.info-text {
  margin: 0;
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.action-button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
}

.action-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
